import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import { type Account, ACCOUNT_SIDE, ACCOUNT_TYPE, PAY_ACCOUNT, type Transact } from './types'
import { faker } from '@faker-js/faker'
import axios from 'axios'
import { useAppStore } from './app'
import { API } from '@/config'

const apiURL: string = API

const api = axios.create({
  baseURL: apiURL + '/v1'
})

export const useAccountStore = defineStore('account', () => {
  const appStore = useAppStore()

  const accounts = reactive(Array<Account>())
  const selectedAccount = ref({} as Account) // selected in table
  const thisAccount = ref({} as Account) //for form editing

  const showForm = ref(false)

  const _accounts = [
    // earnings
    {
      account_number: '1000',
      account_name: 'Basic Salary',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },
    {
      account_number: '1010',
      account_name: 'Absences / UT',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Expenses
    },
    {
      account_number: '1020',
      account_name: 'Overtime',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1030',
      account_name: 'Night Diff.',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1040',
      account_name: 'Uniform Allow.',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1050',
      account_name: 'Super Allow.',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1060',
      account_name: 'Cash Advance',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1080',
      account_name: 'SIL',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1090',
      account_name: '13th Month',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1100',
      account_name: 'Leave Conv. Exempt',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    {
      account_number: '1110',
      account_name: 'Leave Conv. Taxable',
      account_side: ACCOUNT_SIDE.Debit,
      account_type: ACCOUNT_TYPE.Expenses
    },

    // deductions

    {
      account_number: '2010',
      account_name: 'SS Premium',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },

    {
      account_number: '2020',
      account_name: 'PhilHealth',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },

    {
      account_number: '2030',
      account_name: 'Pag-ibig',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },
    {
      account_number: '2040',
      account_name: 'W/Holding Tax',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },
    {
      account_number: '2050',
      account_name: 'Prov. Fund',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },
    
    {
      account_number: '2060',
      account_name: 'Retirement',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },

    {
      account_number: '2070',
      account_name: 'Canteen',
      account_side: ACCOUNT_SIDE.Credit,
      account_type: ACCOUNT_TYPE.Liabilities
    },



  ]

  // The chart numbers calcPay() looks up by hand. Renumbering one of these
  // detaches it from the calculation silently — the lookup misses, the amount is
  // never written, and nothing errors — so the form keeps them read-only.
  const systemAccounts: string[] = Object.values(PAY_ACCOUNT)

  const isSystemAccount = computed(() => (account_number?: string) =>
    account_number != undefined && systemAccounts.includes(account_number)
  )

  function generateAccounts(count = 100) {
    if (accounts.length == 0) {
      _accounts.forEach((account,idx)=> {
        // const account_uuid = faker.string.uuid()
        const payload  = {...account}
        saveAccount(payload)
  
      })
    }

  }


  async function saveAccount(payload: Account) {
    if (payload.uuid) {
      const response = (await api.put('/accounts/' + payload.uuid, payload))

      if (response.status == 200) {
        accounts.push(response.data)
        appStore.errors = {}
        showForm.value = false
      } else {
        appStore.errors = response.data.errors
        showForm.value = true
      }
    } else {
      const response = (await api.post('/accounts.json', payload))

      if (response.status == 200) {
        if ('errors' in response.data) {
          appStore.errors = response.data.errors
          showForm.value = true
        } else {
          accounts.push(response.data)
          appStore.errors = {}
          showForm.value = false
  
        }
      } else {
        appStore.errors = response.data
      }
    }
  }


  async function addAccount(payload: Account) {

    const response = (await api.post('/accounts.json', payload))

    if (response.status == 200) {
      accounts.push(response.data)
    } else {
    }
  }
  
  async function deleteAccount(payload: Account) {
    const response = await api.delete("/accounts/" + payload.uuid);
    // record was actually deleted
    if (response.status == 200) {
      const ndx = accounts.findIndex(
        (item: Account) => item.uuid != payload.uuid
      );
      accounts.splice(ndx,1)
    }
  }

  function railic(payload: Account) {
    // cash in / out
    if ((payload.account_type == ACCOUNT_TYPE.Assets && payload.account_side == ACCOUNT_SIDE.Credit) ||
    (payload.account_type == ACCOUNT_TYPE.Liabilities && payload.account_side == ACCOUNT_SIDE.Debit) ||
    (payload.account_type == ACCOUNT_TYPE.Equities && payload.account_side == ACCOUNT_SIDE.Debit) ||
    (payload.account_type == ACCOUNT_TYPE.Expenses && payload.account_side == ACCOUNT_SIDE.Debit)
    ) {
      return true
    } else {
      return false
    }
  }

  const earningAccounts = computed(() => {

    return accounts.filter(item => railic(item))

  })

  

  const deductionAccounts = computed(() => {

    return accounts.filter(item => !railic(item))

  })

  // Earning -> deduction pairs: each withheld earning mirrors into its deduction
  // account on every payslip. Pairs pointing at a missing or non-deduction account,
  // or from a non-earning account, are ignored so a stale link cannot post a wrong line.
  const withheldPairs = computed(() =>
    accounts
      .filter((item) => item.withheld_account_uuid && railic(item))
      .map((earning) => ({
        earning,
        withheld: accounts.find((acc) => acc.uuid == earning.withheld_account_uuid)
      }))
      .filter(
        (pair): pair is { earning: Account; withheld: Account } =>
          pair.withheld != undefined && pair.withheld.uuid != pair.earning.uuid && !railic(pair.withheld)
      )
  )

  // Accounts whose amounts calcPay() owns: the hand-matched chart numbers, plus the
  // deduction side of every withheld pair (the mirror is derived from its earning).
  // These must not be edited by hand — an edit would freeze the row while the
  // figures it is derived from keep moving.
  const isCalculatedAccount = computed(() => (account_uuid?: string) => {
    const account = accounts.find((item) => item.uuid == account_uuid)
    if (!account) return false
    return (
      isSystemAccount.value(account.account_number) ||
      withheldPairs.value.some((pair) => pair.withheld.uuid == account.uuid)
    )
  })

   const accountName = computed(()=>(uuid: any)=>{
    
    return accounts.find(item=>item.uuid == uuid)?.account_name
   })

   const accountNumber = computed(()=>(uuid: any)=>{
    
    return accounts.find(item=>item.uuid == uuid)?.account_number
   })

  async function getAccounts() {

    const response = (await api.get('/accounts.json'))
    if (response.status == 200) {
      // accounts.length=0
      // response.data.data.forEach((item: Account)=>{
      //   accounts.push(item)
      // })
      Object.assign(accounts,[])
      Object.assign(accounts,response.data.data)
      
    } else {
    }
  }



  return {
    showForm,
    accounts,
    selectedAccount,
    thisAccount,
    generateAccounts,
    getAccounts,
    saveAccount,
    addAccount,
    deleteAccount,
    railic,
    earningAccounts,
    deductionAccounts,
    withheldPairs,
    accountName,
    accountNumber,
    systemAccounts,
    isSystemAccount,
    isCalculatedAccount,
  }
})
